/* Quick view popup */

// document.addEventListener('DOMContentLoaded', function () {
//     const changeOptions = () => {
//         document.querySelectorAll(".main-options input").forEach((e) => {
//             e.addEventListener("change",(evt) => {
//                 var checked_size = document.querySelectorAll(".main-options input:checked").length;
//                 if(checked_size > 1){
//                     let options_value = [];
//                     document.querySelectorAll(".main-options input:checked").forEach((e) => {
//                         let Selected_val = e.value;
//                         options_value.push(Selected_val);
//                     })
//                     var vatiant_title = options_value.join(" / ");
//                     var Selected_Variant = Number(evt.target.closest(".pro-information").querySelector(".all_variants_main input[data-title='"+ vatiant_title +"']").value);
//                     document.querySelector(".custom-quick-add").dataset.id = Selected_Variant;
//                 }else{
//                     var checked_value = document.querySelectorAll(".main-options input:checked")[0].value;
//                     var match_title = Number(evt.target.closest(".pro-information").querySelector(".all_variants_main input[data-title='"+ checked_value +"']").value);
//                     document.querySelector(".custom-quick-add").dataset.id = match_title;
//                 }
//                 Add_to_cart();
//             })
//         })
//     };
//     const Add_to_cart_function = (id) => {
//         let formData = {
//             'items': [{
//                 'id': id,
//                 'quantity': 1
//             }]
//         };
//         fetch(window.Shopify.routes.root + 'cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(formData)
//         })
//             .then(response => {
//                 return response.json();
//             })
//             .catch((error) => {
//                 console.error('Error:', error);
//             });
//     };
//     const Add_to_cart = () => {
//         document.querySelector(".custom-quick-add").addEventListener("click", (e) => {
//             var var_id = Number(e.target.dataset.id);
//             Add_to_cart_function(var_id);
//         })
//     }
//
//     document.querySelectorAll(".custom-quickview").forEach((e) => {
//         e.addEventListener("click",function(evt){
//             //console.log(evt);
//             var $gt_handlee = evt.target.closest("[data-handle]");
//             var $gt_handle = $gt_handlee.dataset.handle;
//             fetch(`/products/${$gt_handle}.json`).then((response)=>{
//                 return response.json()
//             }).then((data) => {
//
//                 var $product = data.product;
//                 console.log("$product--->",$product)
//
//                 // variant options js starts from here
//                 var variant_options = document.createElement("div");
//                 variant_options.setAttribute("class",`main-options`);
//                 $product.options.forEach((option) => {
//                     var option_values = document.createElement("div");
//                     option_values.setAttribute("class",`main-option-${option.name}`);
//                     option.values.forEach((value,index) => {
//                         let label = document.createElement("label");
//                         label.innerText = value;
//                         label.setAttribute("for",`${index}-${value}`);
//                         let input = document.createElement("input");
//                         input.type = "radio";
//                         input.name = option.name;
//                         input.value = value;
//                         input.setAttribute("id",`${index}-${value}`);
//                         label.appendChild(input);
//                         option_values.appendChild(label);
//                     })
//                     var wrapper = document.createElement("div");
//                     //wrapper.appendChild(option_values);
//                     var string_options = wrapper.innerHTML;
//                     var radio_options = `
//                     <div class="option-${option.name}">
//                       <h6>${option.name}</h6>
//                       ${string_options}
//                     </div>
//                   `;
//                     variant_options.innerHTML += radio_options;
//                 })
//                 // end here
//
//                 // variants loop starts from here
//                 var variants_main = document.createElement("div");
//                 variants_main.setAttribute("class","all_variants_main")
//                 $product.variants.forEach((e) => {
//                     let var_input = document.createElement("input");
//                     var_input.type = "hidden";
//                     var_input.value = e.id;
//                     var_input.name = "variant";
//                     var_input.dataset.title = e.title;
//                     variants_main.appendChild(var_input);
//                 })
//                 let variant_wrapper = document.createElement("div");
//                 variant_wrapper.appendChild(variants_main);
//                 let final_Variants = variant_wrapper.innerHTML;
//                 // end
//
//
//                 // append all html
//                 var options_wrapper = document.createElement("div");
//                 options_wrapper.appendChild(variant_options);
//                 var string_options_main = options_wrapper.innerHTML;
//                 var $html = `
//                   <div class="product-main">
//                     <div class="product-media">
//                       <img src="${$product.image.src}" alt="${$product.handle}">
//                     </div>
//                     <div class="pro-information">
//                       ${final_Variants}
//                       <h5>${$product.title}</h5>
//                       <p class="price"></p>
//                       ${string_options_main}
// <!--                      <button type="button" data-id="" class="custom-quick-add">Add to cart</button>-->
//                     </div>
//                   </div>
//                   `;
//                 document.querySelector(".quickview_popup .quickview_pro_inner").innerHTML = $html;
//                 document.querySelector(".quickview_popup").classList.add("active");
//                 changeOptions();
//             })
//         })
//     })
// })


  window.Preview_collectionPageData = {}; // To store product variant  
  window.Preview_productsTag = {}; // To store product tags
  window.Preview_p_ids= {};
$(document).on("click", ".custom-quickview", function (e) {
    //e.preventDefault();
    $(".quickview_popup").addClass("active");
    target = $(this).data("handle");
    var proid = $(this).data("proid");
    var proLowStck = $(this).data("stock");
    if(proLowStck == "Low Stock"){
     var stockStatus = "Low Stock";
    }else{
      var stockStatus = $('.price--sold-out + .quick-add .stock[data-proid="' + proid + '"]').text();
    }
    
    var priceHtml = jQuery('.price[data-proid="' + proid + '"]').prop("outerHTML");
    //console.log(stockStatus);
    handleajaxcalled(target , stockStatus, priceHtml,proLowStck);
    handleajaxcalledrelatedproducts(proid);
});
async function productsjaxcalled(formattedIds) {
  
let responseData = await $.ajax({
    type: 'POST', // Change to GET, PUT, DELETE as needed
    url: 'https://appbackend.preorderbat.com/node/api/pre-order-products',
    data: JSON.stringify({
            shop: "gametraders-blacktown-1.myshopify.com",
            product_ids: formattedIds
        }),
    contentType: 'application/json',
    headers: {
        'Authorization': 'Bearer your-token'
    },
    success: function(response) {
        return response.data;
    },
    error: function(xhr, status, error) {
        console.log('Error:', error);
        if (error === 'Network Error') {
            console.log('Server is not responding, please try again after some time');
        }
    }
});
      return responseData.data;
  
}
function handleajaxcalled(target,stockStatus,priceHtml) {
    //Get Products
    //alert(target);
    $.ajax({
        url: '/products/' + target + '.json',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            var products = data.product;
            //console.log(products);
            displayProduct(products,stockStatus,priceHtml);
            const swiperContainer = document.querySelector('.mySwiper');
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            var swiper = new Swiper(".mySwiper", {
                loop: true,
                spaceBetween: 10,
                slidesPerView: 3,
                freeMode: true,
                watchSlidesProgress: true,
              navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
            var swiper2 = new Swiper(".mySwiper2", {
                loop: true,
                spaceBetween: 10,
              
                thumbs: {
                    swiper: swiper,
                },
            });

          // Check the number of slides
          if (slides.length <= 3) {
             // Remove the navigation arrows
           swiper.navigation.destroy();
            document.querySelector('.mySwiper .swiper-button-next').style.visibility = 'hidden';
            document.querySelector('.mySwiper .swiper-button-prev').style.visibility = 'hidden';
          }

          // Pre order release notification

          // Pre order bat app initialise check
  // Target the element you want to observe (adjust the selector as needed)
    const targetNodePreOrder = document.querySelector('.quickview_popup.active');

    // Check if the target node exists
    if (targetNodePreOrder) {
      
        // Create a new MutationObserver
        const observer = new MutationObserver(function(mutations) {

          //alert('1445');


           mutations.forEach(function(mutation) {
            // Check if new nodes have been added to the DOM
            mutation.addedNodes.forEach(function(addedNode) {
                //console.log(addedNode.id);
                // Check if the added node has the id 'pre_msg'
                if (addedNode.classList && addedNode.classList.contains('pre-order-message')) {
                    // Custom code to run when the element with id 'pre_msg' is added
                    //alert("Element with id 'pre_msg' added to the DOM.");

                    // Your custom jQuery code or actions
                      jQuery('.quickview_popup.active #pre_msg').append("<a class='policy-link' href='/pages/pre-order-policy'> Read our Pre-Order Policy</a>");
                      jQuery('.quickview_popup.active #pre_msg').addClass("preorder-description");
                      var preorderDesc = jQuery('.quickview_popup.active #pre_msg').get(0).outerHTML;
                      jQuery('.quickview_popup.active .description').after(preorderDesc);
                      jQuery('.quickview_popup.active .preorder-description').removeAttr("id","pre_msg");
                      jQuery('.quickview_popup.active .stock-sts span.available').addClass("pre-order");
                    
                    // Optionally disconnect the observer if you no longer need to watch for this element
                    observer.disconnect();
                }
            });
        });

        });

        // Observer configuration
        const configpre = { childList: true, subtree: true };

        // Start observing the target node for configured mutations
        observer.observe(targetNodePreOrder, configpre);
    } else {
        console.log("Target node not found. Please check your selector.");
    } 

          
          
          
        },
        error: function (xhr, status, error) {
            console.error('AJAX request failed:', error);
        }
    });
}

function handleajaxcalledrelatedproducts(proid) {
    //Get Products
    //alert(target);
    var productsToFetch = 4;
    $.ajax({
        //url: '/collections/'+ collectionhandle +'/products.json?limit=' + productsToFetch,
        url : '/recommendations/products.json?product_id='+ proid +'&limit=4&intent=related',
        type: 'GET',
        dataType: 'json',
        success: function (data) {
            var products = data.products;
            //console.log(products);
            displayRelatedProducts(products);
        },
        error: function (xhr, status, error) {
            console.error('AJAX request failed:', error);
        }
    });
}

// Function to format price
function formatPrice(price) {
    return (price / 100).toFixed(2);
    //return parseFloat(price).toFixed(2); // Format to 2 decimal places
}

async function displayRelatedProducts(products){
    JSON.stringify(products);
    //console.log(products);
    var relatedProductHtml = '';
 const formattedIds = products.map(product => `id:${product.id}`).join(" OR ");
  let prodcuts_ineventory  = await productsjaxcalled(formattedIds);
     relatedProductHtml += `
    <h2 class="relatedproductstitle">You May Also Like</h2>
<ul id="product-grid" data-id="template--15827059867746__product-grid" class="
                grid product-grid grid--2-col-tablet-down
                grid--4-col-desktop
                
              ">`;

     products.forEach(function(product) {
 const productKey = product.handle;
                        // Process for Preview_collectionPageData
                        const variantData = product.variants.map(variant => {
                            // Find matching inventory data
                            let inventoryItem = prodcuts_ineventory.filter(item => item.variantId == variant.id);
                              console.log("inventoryItem",inventoryItem[0].inventoryQuantity)
                            return {
                                [variant.id]: inventoryItem[0] ? inventoryItem[0].inventoryQuantity : 2 // Default to -1 if no match found
                            };
                        });
                        Preview_collectionPageData[productKey] = variantData;
    
                        // Process for Preview_productsTag
                        const tags = product.tags.join(",");
                        Preview_productsTag[productKey] = `,${tags}`;
    
                        // Process for p_ids
                        const variantIds = product.variants.map(variant => variant.id);
                        Preview_p_ids[productKey] = {
                            prodcut_id: product.id,
                            var_ids: variantIds
                        };
const priceFormatted = formatPrice(product.variants[0].price); // Format price
relatedProductHtml += `<li class="grid__item scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: 1;">
                  
<div class="card-wrapper product-card-wrapper underline-links-hover">
    <div class="
        card card--card
         card--media
         color-scheme-1 gradient" style="--ratio-percent: 100%;">
      <div class="card__inner  ratio" style="--ratio-percent: 100%;"><div class="card__media">
            <div class="media media--transparent media--hover-effect">
              <img src="${product.featured_image}" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${product.title}" class="motion-reduce">
              </div>
          </div><div class="card__content">
          <div class="card__information">
            <h3 class="card__heading">
              <a href="/products/${product.handle}" id="StandardCardNoMediaLink-template--15827059867746__product-grid-7213878444130" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--15827059867746__product-grid-7213878444130 NoMediaStandardBadge-template--15827059867746__product-grid-7213878444130">
                ${product.title}
              </a>
            </h3>
          </div>
         

          
            <div class="card__badge top left"></div>
          
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <h3 class="card__heading h5" id="title-template--15827059867746__product-grid-${product.id}">
            <a href="/products/${product.handle}" id="CardLink-template--15827059867746__product-grid-${product.id}" class="full-unstyled-link" aria-labelledby="CardLink-template--15827059867746__product-grid-${product.id} Badge-template--15827059867746__product-grid-${product.id}">
              ${product.title}
            </a>
          </h3>
          <div class="card-information"><span class="caption-large light"></span>
<div class="
    price ">
  <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">
          <span class="money">$${priceFormatted} </span>
        </span></div>
    <div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span>
          <s class="price-item price-item--regular">
            
              
            
          </s>
        </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last">
        <span class="money">$${priceFormatted} </span>
      </span>
    </div>
    <small class="unit-price caption hidden">
      <span class="visually-hidden">Unit price</span>
      <span class="price-item price-item--last">
        <span></span>
        <span aria-hidden="true">/</span>
        <span class="visually-hidden">&nbsp;per&nbsp;</span>
        <span>
        </span>
      </span>
    </small>
  </div></div>


            
              <div class="quick-add no-js-hidden"><product-form data-section-id="template--15827059867746__product-grid"><form method="post" action="/cart/add" id="quick-add-template--15827059867746__product-grid${product.handle}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
                      <button id="quick-add-template--15827059867746__product-grid${product.handle}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="quick-add-template--15827059867746__product-grid7213878444130-submit title-template--15827059867746__product-grid-${product.handle}" aria-live="polite" data-sold-out-message="true">
                    <span>

                        
                          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="40" viewBox="0 0 56 40" fill="none">
    <rect width="56" height="40" rx="20" fill="#6D3078"></rect>
    <path d="M23.5 15.67V14.7C23.5 12.45 25.31 10.24 27.56 10.03C30.24 9.77001 32.5 11.88 32.5 14.51V15.89" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M25.0001 30H31.0001C35.0201 30 35.7401 28.39 35.9501 26.43L36.7001 20.43C36.9701 17.99 36.2701 16 32.0001 16H24.0001C19.7301 16 19.0301 17.99 19.3001 20.43L20.0501 26.43C20.2601 28.39 20.9801 30 25.0001 30Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M31.4955 20H31.5045" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M24.4945 20H24.5035" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg> <svg xmlns="http://www.w3.org/2000/svg" width="149" height="40" viewBox="0 0 149 40" fill="none">
    <rect width="149" height="40" rx="20" fill="#6D3078"></rect>
    <path d="M23.5 15.67V14.7C23.5 12.45 25.31 10.24 27.56 10.03C30.24 9.77001 32.5 11.88 32.5 14.51V15.89" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M25.0001 30H31.0001C35.0201 30 35.7401 28.39 35.9501 26.43L36.7001 20.43C36.9701 17.99 36.2701 16 32.0001 16H24.0001C19.7301 16 19.0301 17.99 19.3001 20.43L20.0501 26.43C20.2601 28.39 20.9801 30 25.0001 30Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M31.4955 20H31.5045" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M24.4945 20H24.5035" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M49.4764 26V14.8H54.9484C56.3564 14.8 57.4124 15.0667 58.1164 15.6C58.8311 16.1333 59.1884 16.8373 59.1884 17.712C59.1884 18.2987 59.0444 18.8107 58.7564 19.248C58.4684 19.6747 58.0738 20.0053 57.5724 20.24C57.0711 20.4747 56.4951 20.592 55.8444 20.592L56.1484 19.936C56.8524 19.936 57.4764 20.0533 58.0204 20.288C58.5644 20.512 58.9858 20.848 59.2844 21.296C59.5938 21.744 59.7484 22.2933 59.7484 22.944C59.7484 23.904 59.3698 24.656 58.6124 25.2C57.8551 25.7333 56.7404 26 55.2684 26H49.4764ZM52.0524 24.048H55.0764C55.7484 24.048 56.2551 23.9413 56.5964 23.728C56.9484 23.504 57.1244 23.152 57.1244 22.672C57.1244 22.2027 56.9484 21.856 56.5964 21.632C56.2551 21.3973 55.7484 21.28 55.0764 21.28H51.8604V19.392H54.6284C55.2578 19.392 55.7378 19.2853 56.0684 19.072C56.4098 18.848 56.5804 18.512 56.5804 18.064C56.5804 17.6267 56.4098 17.3013 56.0684 17.088C55.7378 16.864 55.2578 16.752 54.6284 16.752H52.0524V24.048ZM66.6868 26.192C65.0975 26.192 63.8548 25.7493 62.9588 24.864C62.0628 23.9787 61.6148 22.7147 61.6148 21.072V14.8H64.2068V20.976C64.2068 22.0427 64.4255 22.8107 64.8628 23.28C65.3001 23.7493 65.9135 23.984 66.7028 23.984C67.4921 23.984 68.1055 23.7493 68.5428 23.28C68.9801 22.8107 69.1988 22.0427 69.1988 20.976V14.8H71.7588V21.072C71.7588 22.7147 71.3108 23.9787 70.4148 24.864C69.5188 25.7493 68.2761 26.192 66.6868 26.192ZM76.9479 26V21.424L77.5399 22.992L72.6119 14.8H75.3639L79.1399 21.088H77.5559L81.3479 14.8H83.8919L78.9639 22.992L79.5399 21.424V26H76.9479ZM89.5077 26V14.8H91.6517L98.2597 22.864H97.2197V14.8H99.7797V26H97.6517L91.0277 17.936H92.0677V26H89.5077ZM107.87 26.192C106.984 26.192 106.163 26.048 105.406 25.76C104.659 25.472 104.008 25.0667 103.454 24.544C102.91 24.0213 102.483 23.408 102.174 22.704C101.875 22 101.726 21.232 101.726 20.4C101.726 19.568 101.875 18.8 102.174 18.096C102.483 17.392 102.915 16.7787 103.47 16.256C104.024 15.7333 104.675 15.328 105.422 15.04C106.168 14.752 106.979 14.608 107.854 14.608C108.739 14.608 109.55 14.752 110.286 15.04C111.032 15.328 111.678 15.7333 112.222 16.256C112.776 16.7787 113.208 17.392 113.518 18.096C113.827 18.7893 113.982 19.5573 113.982 20.4C113.982 21.232 113.827 22.0053 113.518 22.72C113.208 23.424 112.776 24.0373 112.222 24.56C111.678 25.072 111.032 25.472 110.286 25.76C109.55 26.048 108.744 26.192 107.87 26.192ZM107.854 23.984C108.355 23.984 108.814 23.8987 109.23 23.728C109.656 23.5573 110.03 23.312 110.35 22.992C110.67 22.672 110.915 22.2933 111.086 21.856C111.267 21.4187 111.358 20.9333 111.358 20.4C111.358 19.8667 111.267 19.3813 111.086 18.944C110.915 18.5067 110.67 18.128 110.35 17.808C110.04 17.488 109.672 17.2427 109.246 17.072C108.819 16.9013 108.355 16.816 107.854 16.816C107.352 16.816 106.888 16.9013 106.462 17.072C106.046 17.2427 105.678 17.488 105.358 17.808C105.038 18.128 104.787 18.5067 104.606 18.944C104.435 19.3813 104.35 19.8667 104.35 20.4C104.35 20.9227 104.435 21.408 104.606 21.856C104.787 22.2933 105.032 22.672 105.342 22.992C105.662 23.312 106.035 23.5573 106.462 23.728C106.888 23.8987 107.352 23.984 107.854 23.984ZM118.258 26L114.594 14.8H117.282L120.466 24.72H119.122L122.45 14.8H124.85L128.05 24.72H126.754L130.018 14.8H132.498L128.834 26H126.05L123.218 17.296H123.954L121.042 26H118.258Z" fill="white"></path>
</svg>
                        
</span>
                        <span class="sold-out-message hidden">
                      Sold out
                    </span>

<div class="loading__spinner hidden">
  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
  </svg>
</div>
</button><input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--15827059867746__product-grid"></form></product-form></div>
            

          </div>
        </div>

        <div class="card__badge top left"></div>
      </div>
    </div>
  </div>
                </li>`;
    });

    relatedProductHtml += `</ul>`;

    $(".quickview_popup .quickview_pro_inner").append(relatedProductHtml);

}

function displayProduct(product,stockStatus,priceHtml) {
    var productHtml = '';
    JSON.stringify(product);
    console.log(priceHtml);
    var permalinkURL = window.location.origin + '/products/' + product.handle;

    let text = product.tags;
    console.log(text);
    let addToCartText = '';
    let buttonSvg = '';
    let isPreOrder = text.includes("Pre-Order");
    let stockstatus = '';
    let disabled = '';
    if(isPreOrder == true){
        stockstatus = 'Pre-order';
        isPreOrder = 'pre-order';
        addToCartText  = 'Pre-order';
        buttonSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\n' +
            '<path d="M22.5 12C22.5 17.52 18.02 22 12.5 22C6.98 22 2.5 17.52 2.5 12C2.5 6.48 6.98 2 12.5 2C18.02 2 22.5 6.48 22.5 12Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '<path d="M16.2099 15.18L13.1099 13.33C12.5699 13.01 12.1299 12.24 12.1299 11.61V7.51001" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
            '</svg>';
    }else{
        if(stockStatus.includes("Sold out")){
            disabled = "disabled";
            stockstatus = "Out of stock";
            isPreOrder = 'not-pre-order sold-out';
            addToCartText  = 'Sold out';
        }else if(stockStatus == 'Low Stock'){
            stockstatus = 'Low Stock';
            isPreOrder = 'not-pre-order';
            addToCartText  = 'Add to cart';
            buttonSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\n<path d="M8 7.67001V6.70001C8 4.45001 9.81 2.24001 12.06 2.03001C14.74 1.77001 17 3.88001 17 6.51001V7.89001" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M9.5008 22H15.5008C19.5208 22 20.2408 20.39 20.4508 18.43L21.2008 12.43C21.4708 9.99 20.7708 8 16.5008 8H8.5008C4.2308 8 3.5308 9.99 3.8008 12.43L4.5508 18.43C4.7608 20.39 5.4808 22 9.5008 22Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M15.9945 12H16.0035" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M8.99451 12H9.00349" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
        }else{
            stockstatus = 'In Stock';
            isPreOrder = 'not-pre-order';
            addToCartText  = 'Add to cart';
            buttonSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\n<path d="M8 7.67001V6.70001C8 4.45001 9.81 2.24001 12.06 2.03001C14.74 1.77001 17 3.88001 17 6.51001V7.89001" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M9.5008 22H15.5008C19.5208 22 20.2408 20.39 20.4508 18.43L21.2008 12.43C21.4708 9.99 20.7708 8 16.5008 8H8.5008C4.2308 8 3.5308 9.99 3.8008 12.43L4.5508 18.43C4.7608 20.39 5.4808 22 9.5008 22Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M15.9945 12H16.0035" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n<path d="M8.99451 12H9.00349" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
        }
    }
    /*productHtml += `
      <div class="product">
        <img class="product-image-menu" src="${product.images[0].src}" alt="${product.title}">
        <p class="product-menu-title">${product.title}</p>
        <p>Price: $${product.variants[0].price}</p>
        <a href="${product.handle}" class="button">View Product</a>
      </div>
    `;*/
//         productHtml += `
//   <div class="card-wrapper product-card-wrapper underline-links-hover">
//     <div class="
//         card card--card
//          card--media
//          color-scheme-1 gradient
//       " style="--ratio-percent: 100%;">
//       <div class="card__inner  ratio" style="--ratio-percent: 100%;"><div class="card__media">
//             <div class="media media--transparent media--hover-effect">
//               <img src="${product.images[0].src}&amp;width=533" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" alt="${product.title}" class="motion-reduce">
// </div>
//           </div><div class="card__content">
//           <div class="card__information">
//             <h3 class="card__heading">
//               <a href="/products/${product.handle}" id="StandardCardNoMediaLink-template--15827059900514__featured_collection-${product.id}" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--15827059900514__featured_collection-${product.id} NoMediaStandardBadge-template--15827059900514__featured_collection-${product.id}">
//                 ${product.title}
//               </a>
//             </h3>
//           </div>
//           <div class="card__badge top left"></div>
//         </div>
//       </div>
//       <div class="card__content">
//         <div class="card__information">
//           <h3 class="card__heading h5" id="title-template--15827059900514__featured_collection-${product.id}">
//             <a href="/products/${product.handle}" id="CardLink-template--15827059900514__featured_collection-${product.id}" class="full-unstyled-link" aria-labelledby="CardLink-template--15827059900514__featured_collection-${product.id} Badge-template--15827059900514__featured_collection-${product.id}">
//               ${product.title}
//             </a>
//           </h3>
//           <div class="card-information"><span class="caption-large light"></span>
// <div class="
//     price ">
//   <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
//         <span class="price-item price-item--regular">
//           <span class="money">$${product.variants[0].price}</span>
//         </span></div>
//     <div class="price__sale">
//         <span class="visually-hidden visually-hidden--inline">Regular price</span>
//         <span>
//           <s class="price-item price-item--regular">
//           </s>
//         </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
//       <span class="price-item price-item--sale price-item--last">
//         <span class="money">$${product.variants[0].price}</span>
//       </span>
//     </div>
//     <small class="unit-price caption hidden">
//       <span class="visually-hidden">Unit price</span>
//       <span class="price-item price-item--last">
//         <span></span>
//         <span aria-hidden="true">/</span>
//         <span class="visually-hidden">&nbsp;per&nbsp;</span>
//         <span>
//         </span>
//       </span>
//     </small>
//   </div></div>
//               <div class="quick-add no-js-hidden">
//               <product-form data-section-id="template--15827059900514__featured_collection">
//               <form method="post" action="/cart/add" id="quick-add-template--15827059900514__featured_collection${product.handle}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
//               <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
//               <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
//                       <button id="quick-add-template--15827059900514__featured_collection${product.id}-submit" type="submit" name="add"
//                       class="quick-add__submit button button--full-width button--secondary"
//                       aria-haspopup="dialog"
//                       aria-labelledby="quick-add-template--15827059900514__featured_collection${product.id}-submit title-template--15827059900514__featured_collection-${product.id}" aria-live="polite" data-sold-out-message="true">
//                     <span>
//                         <svg xmlns="http://www.w3.org/2000/svg" width="56" height="40" viewBox="0 0 56 40" fill="none">
//     <rect width="56" height="40" rx="20" fill="#6D3078"></rect>
//     <path d="M23.5 15.67V14.7C23.5 12.45 25.31 10.24 27.56 10.03C30.24 9.77001 32.5 11.88 32.5 14.51V15.89" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
//     <path d="M25.0001 30H31.0001C35.0201 30 35.7401 28.39 35.9501 26.43L36.7001 20.43C36.9701 17.99 36.2701 16 32.0001 16H24.0001C19.7301 16 19.0301 17.99 19.3001 20.43L20.0501 26.43C20.2601 28.39 20.9801 30 25.0001 30Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
//     <path d="M31.4955 20H31.5045" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
//     <path d="M24.4945 20H24.5035" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
// </svg>
// </span>
//                         <span class="sold-out-message hidden">
//                       Sold out
//                     </span>
//
// <div class="loading__spinner hidden">
//   <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
//     <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
//   </svg>
// </div>
// </button><input type="hidden" name="product-id" value="${product.id}">
// <input type="hidden" name="section-id" value="template--15827059900514__featured_collection"></form></product-form></div>
//           </div>
//         </div>
//         <div class="card__badge top left"></div>
//       </div>
//     </div>
//   </div>`;

    productHtml += `<div class="product product--thumbnail_slider product--large product--left product--mobile-hide grid grid--1-col grid--2-col-tablet">
  <div class="grid__item product__media-wrapper">`;
  
    


  productHtml+= `<div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="swiper mySwiper2">
    <div class="swiper-wrapper">`;

    var imgsArray = product.images;
    for (let i = 0; i < imgsArray.length; i++) {
        productHtml+= `
      <div class="swiper-slide">
        <img src="${imgsArray[i].src}" />
      </div>`;
    }

    productHtml+= `</div>
  
  </div>
  <div thumbsSlider="" class="swiper mySwiper">
    <div class="swiper-wrapper">`;
    var imgsArray = product.images;
    for (let i = 0; i < imgsArray.length; i++) {
        productHtml+= `
      <div class="swiper-slide">
        <img src="${imgsArray[i].src}" />
      </div>`;
    }

    productHtml+= `</div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
    
  </div>
  <div class="product__info-wrapper grid__item scroll-trigger animate--slide-in">
    <section id="ProductInfo-template--15827060064354__main" class="product__info-container product__column-sticky">
      <div class="product__title">
        <a href="/products/${product.handle}" class="product__title">
          <h1 class="h1"> ${product.title} </h1>
        </a>
      </div>
      <div class="meta-wrap">
        <span>SKU: ${product.variants[0].sku}</span>
        <span class="social-ico">
          <a href="javascript:void(0)" onclick="window.open('//www.facebook.com/sharer.php?u=${permalinkURL}','Facebook Share' , 'popup=yes')">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
              <path d="M6.24091 16V8.70218H8.6895L9.05686 5.85725H6.24091V4.04118C6.24091 3.21776 6.46863 2.65661 7.65074 2.65661L9.15597 2.65599V0.111384C8.89566 0.0775563 8.00212 0 6.96212 0C4.79044 0 3.30367 1.32557 3.30367 3.75942V5.85725H0.847656V8.70218H3.30367V16H6.24091Z" fill="#010002" />
            </svg>
          </a>
          <a href="javascript:void(0)" onclick="window.open('//twitter.com/share?url=${permalinkURL}&amp;text=${product.title}','Twitter Tweet' , 'popup=yes')">
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2.039C15.405 2.3 14.771 2.473 14.11 2.557C14.79 2.151 15.309 1.513 15.553 0.744C14.919 1.122 14.219 1.389 13.473 1.538C12.871 0.897 12.013 0.5 11.077 0.5C9.261 0.5 7.799 1.974 7.799 3.781C7.799 4.041 7.821 4.291 7.875 4.529C5.148 4.396 2.735 3.089 1.114 1.098C0.831 1.589 0.665 2.151 0.665 2.756C0.665 3.892 1.25 4.899 2.122 5.482C1.595 5.472 1.078 5.319 0.64 5.078C0.64 5.088 0.64 5.101 0.64 5.114C0.64 6.708 1.777 8.032 3.268 8.337C3.001 8.41 2.71 8.445 2.408 8.445C2.198 8.445 1.986 8.433 1.787 8.389C2.212 9.688 3.418 10.643 4.852 10.674C3.736 11.547 2.319 12.073 0.785 12.073C0.516 12.073 0.258 12.061 0 12.028C1.453 12.965 3.175 13.5 5.032 13.5C11.068 13.5 14.368 8.5 14.368 4.166C14.368 4.021 14.363 3.881 14.356 3.742C15.007 3.28 15.554 2.703 16 2.039Z" fill="#010101" />
            </svg>
          </a>
          <a href="javascript:void(0)" onclick="window.open('//pinterest.com/pin/create/button/?url=${permalinkURL}&amp;media=${imgsArray[0].src}&amp;description=${product.title}','Pinterest Share' , 'popup=yes')">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.2173 0C3.8321 0 1.5 2.81013 1.5 5.87426C1.5 7.29533 2.29404 9.06741 3.56509 9.62943C3.7581 9.71644 3.86311 9.67943 3.90611 9.50043C3.94411 9.36442 4.11112 8.70939 4.19212 8.40038C4.21712 8.30137 4.20412 8.21537 4.12412 8.12236C3.7021 7.63434 3.36708 6.7453 3.36708 5.91127C3.36708 3.77417 5.06616 1.69908 7.95729 1.69908C10.4574 1.69908 12.2065 3.32315 12.2065 5.64625C12.2065 8.27137 10.8174 10.0875 9.01234 10.0875C8.01329 10.0875 7.26926 9.30342 7.50527 8.33337C7.79028 7.17832 8.34931 5.93627 8.34931 5.10323C8.34931 4.3562 7.92729 3.73817 7.06525 3.73817C6.0482 3.73817 5.22317 4.74521 5.22317 6.09727C5.22317 6.95631 5.52718 7.53634 5.52718 7.53634C5.52718 7.53634 4.52114 11.6005 4.33413 12.3596C4.01811 13.6446 4.37713 15.7257 4.40813 15.9047C4.42713 16.0037 4.53814 16.0347 4.60014 15.9537C4.69914 15.8237 5.9152 14.0886 6.25621 12.8346C6.38022 12.3776 6.88924 10.5245 6.88924 10.5245C7.22426 11.1295 8.1913 11.6365 9.22135 11.6365C12.2855 11.6365 14.4996 8.9434 14.4996 5.60125C14.4886 2.39711 11.7465 0 8.2173 0Z" fill="#010101" />
            </svg>
          </a>
          <a href="javascript:emailthisProduct('${permalinkURL}')" class="share-google">
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.668 11.6668H3.33464C2.62762 11.6661 1.94978 11.3849 1.44985 10.8849C0.949916 10.385 0.668722 9.70718 0.667969 9.00016V3.00016C0.668722 2.29315 0.949916 1.61531 1.44985 1.11538C1.94978 0.615443 2.62762 0.33425 3.33464 0.333496H12.668C13.375 0.33425 14.0528 0.615443 14.5528 1.11538C15.0527 1.61531 15.3339 2.29315 15.3346 3.00016V9.00016C15.3339 9.70718 15.0527 10.385 14.5528 10.8849C14.0528 11.3849 13.375 11.6661 12.668 11.6668ZM3.33464 1.66683C2.98114 1.66723 2.64223 1.80784 2.39227 2.0578C2.14231 2.30776 2.00171 2.64666 2.0013 3.00016V9.00016C2.00171 9.35366 2.14231 9.69256 2.39227 9.94252C2.64223 10.1925 2.98114 10.3331 3.33464 10.3335H12.668C13.0215 10.3331 13.3604 10.1925 13.6103 9.94252C13.8603 9.69256 14.0009 9.35366 14.0013 9.00016V3.00016C14.0009 2.64666 13.8603 2.30776 13.6103 2.0578C13.3604 1.80784 13.0215 1.66723 12.668 1.66683H3.33464Z" fill="#010101" />
              <path d="M8.00092 6.95605C7.25939 6.95632 6.53901 6.70897 5.95405 6.25325L1.59138 2.86002C1.45178 2.75141 1.36104 2.59179 1.33913 2.41628C1.31721 2.24077 1.36591 2.06375 1.47452 1.92415C1.58313 1.78454 1.74275 1.69381 1.91826 1.67189C2.09377 1.64997 2.27079 1.69868 2.4104 1.80729L6.77302 5.20051C7.12386 5.47407 7.55601 5.62263 8.00089 5.62263C8.44577 5.62263 8.87792 5.47407 9.22876 5.20051L13.5914 1.80729C13.731 1.69868 13.908 1.64997 14.0835 1.67189C14.259 1.69381 14.4186 1.78454 14.5273 1.92415C14.6359 2.06375 14.6846 2.24077 14.6627 2.41628C14.6407 2.59179 14.55 2.75141 14.4104 2.86002L10.0477 6.25325C9.46271 6.70882 8.7424 6.95615 8.00092 6.95605Z" fill="#010101" />
            </svg>
          </a>
        </span>
      </div>

      <div class="description">  </div>
      <div id="price-template--15827060064354__main" role="status">
        <div class="price price--large price--show-badge">
          ${priceHtml}
          <div class="stock-sts"> Availability: <span class="available ${isPreOrder}">${stockstatus}</span>
          </div>
          <span class="badge price__badge-sale color-scheme-4"> Sale </span>
          <span class="badge price__badge-sold-out color-scheme-5"> Sold out </span>
        </div>
      </div>
      <div>
        <form method="post" action="/cart/add" id="product-form-installment-template--15827060064354__main" accept-charset="UTF-8" class="installment caption-large" enctype="multipart/form-data">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${product.id}">
          <input type="hidden" name="product-id" value="${product.id}">
          <input type="hidden" name="section-id" value="template--15827060064354__main">
        </form>
      </div>
      <div id="Quantity-Form-template--15827060064354__main" class="product-form__input product-form__quantity">
        <label class="quantity__label form__label" for="Quantity-template--15827060064354__main">  <span class="quantity__rules-cart hidden">
            <div class="loading__spinner hidden">
              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
            <span>( <span class="quantity-cart">0</span> in cart) </span>
          </span>
        </label>
        <div class="price-per-item__container">
          <quantity-input class="quantity" data-url="/products/one-piece-general-franky-us-exclusive-pop-vinyl" data-section="template--15827060064354__main">
            <button class="quantity__button disabled" name="minus" type="button">
              <span class="visually-hidden">Decrease quantity for One Piece - General Franky US Exclusive Pop! Vinyl</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg>
            </button>
            <input class="quantity__input" type="number" name="quantity" id="Quantity-template--15827060064354__main" data-cart-quantity="0" data-min="1" min="1" step="1" value="1" form="product-form-template--15827060064354__main">
            <button class="quantity__button" name="plus" type="button">
              <span class="visually-hidden">Increase quantity for One Piece - General Franky US Exclusive Pop! Vinyl</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg>
            </button>
          </quantity-input>
        </div>
        <div class="quantity__rules caption" id="Quantity-Rules-template--15827060064354__main"></div>
      </div>
      <div>
        <product-form class="product-form" data-hide-errors="false" data-section-id="template--15827060064354__main">
          <div class="product-form__error-message-wrapper" role="alert" hidden="">
            <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
              <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
              <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
              <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
              <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
            </svg>
            <span class="product-form__error-message"></span>
          </div>
          <form method="post" action="/cart/add" id="product-form-template--15827060064354__main" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
            <input type="hidden" name="form_type" value="product">
            <input type="hidden" name="utf8" value="✓">
            <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
            <div class="product-form__buttons ${isPreOrder}">
              <button ${disabled} id="ProductSubmitButton-template--15827060064354__main" type="submit" name="add" class="product-form__submit button button--full-width button--secondary">
                <span>${buttonSvg} ${addToCartText} </span>
                <div class="loading__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </div>
            <input type="hidden" name="product-id" value="${product.id}">
            <input type="hidden" name="section-id" value="template--15827060064354__main">
          </form>
      </div>
      </product-form>
      <div class="pay-mthods">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/afterpay.svg?v=1728459099">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/Payment_method_icon_3.svg?v=1728468857">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/Payment_method_icon_2.svg?v=1728468857">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/Payment_method_icon_1.svg?v=1728468857">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/Payment_method_icon_51a2372a-faae-4f9d-a381-15cf35f78768.svg?v=1728468857">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/Apple_Pay_Card_1.svg?v=1728468705">
<img src="https://cdn.shopify.com/s/files/1/0036/0506/9922/files/google-pay-svgrepo-com_1.svg?v=1728459729">
</div>
  </div>
  
  </section>
</div>
</div>
`;

    //$('.Product-data').html(productHtml);
    $(".quickview_popup .quickview_pro_inner").html(productHtml);
}

function emailthisProduct(permlink){
    window.location.href="mailto:?subject="+document.title+"&body="+escape(permlink);
}
// Close quick view

$(document).on("click", ".quickview_popup.active .icon-close" , function () {
    $(".quickview_popup").removeClass("active");
    var empty_html = '';
    $(".quickview_popup .quickview_pro_inner").html(empty_html);
});
